import React from "react";
import { Card, CardTitle } from "../ui/Card";
import RadioGroup from "../ui/RadioGroup";
import { PRIMARY_EMAIL_OPTIONS } from "../options";

// Only shown to retailers - a customer's primary email is always their own.
export default function PrimaryEmailSection({ form, attempted = false }) {
  const { values, setField } = form;

  const showError = attempted && values.primaryEmail === null;

  return (
    <Card radius="panel" className="rma-nc-card--compact">
      <CardTitle
        className="rma-nc-card-title-row--flush"
        aside={
          <RadioGroup
            name="primary-email"
            options={PRIMARY_EMAIL_OPTIONS}
            value={values.primaryEmail}
            onChange={(answer) => setField("primaryEmail", answer)}
          />
        }
      >
        Primary email
      </CardTitle>
      {showError && <p className="rma-nc-error-text">Please select a primary email</p>}
      <p className="rma-nc-field-hint">
        Note: This email address will be used as the primary contact for receiving notifications.
      </p>
    </Card>
  );
}
